import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { MenuItem, FormControl, InputLabel, TextField, Button, Container, Typography, Grid, Select } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';

const EditUser = () => {
  const { id } = useParams();
  const navigate = useNavigate();

    const baseUrl = process.env.REACT_APP_BASE_URL;


  const [firstname, setFirstname] = useState('');
  const [middlename, setMiddlename] = useState('');
  const [lastname, setLastname] = useState('');
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [role, setRole] = useState('');

  const [roles, setRoles] = useState([]);

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    const token = localStorage.getItem('token');

    // Fetch roles
    axios.get(`${baseUrl}/api/roles`, {
      signal,
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then(response => setRoles(response.data))
      .catch(error => {
        if (axios.isCancel(error)) {
          console.log('Fetch roles request canceled:', error.message);
        } else {
          console.error('Error fetching roles:', error);
        }
      });

    // Fetch user data
    axios.get(`${baseUrl}/auth/users/${id}`, {
      signal,
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then(response => {
        const user = response.data;
        setFirstname(user.firstname || '');
        setMiddlename(user.middlename || '');
        setLastname(user.lastname || '');
        setUsername(user.username || '');
        setEmail(user.email || '');
        setRole(user.role || '');
      })
      .catch(error => {
        if (axios.isCancel(error)) {
          console.log('Fetch user data request canceled:', error.message);
        } else {
          console.error('Error fetching user data:', error);
        }
      });

    return () => {
      controller.abort(); // Cleanup: Cancel all requests if the component unmounts
    };
  }, [id, baseUrl]);

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      await axios.put(`${baseUrl}/auth/editUsers/${id}`, {
        firstname, middlename, lastname, username, email, password, role
      }, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      alert('Update successful');
      navigate('/dashboard/users');
    } catch (error) {
      alert('Update failed');
      console.error('Error updating user:', error);
      if (error.response) {
        console.error('Error response:', error.response.data);
      }
    }
  };

  return (
    <Container maxWidth="xl">
      <Typography variant="h4" component="h1" sx={{ mt: 2 }} gutterBottom>
        Edit User
      </Typography>
      <form onSubmit={handleUpdate}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              margin="normal"
              label="First Name"
              variant="outlined"
              value={firstname}
              onChange={(e) => setFirstname(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              margin="normal"
              label="Middle Name"
              variant="outlined"
              value={middlename}
              onChange={(e) => setMiddlename(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              margin="normal"
              label="Last Name"
              variant="outlined"
              value={lastname}
              onChange={(e) => setLastname(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              margin="normal"
              label="Username"
              variant="outlined"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              margin="normal"
              label="Email"
              variant="outlined"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              margin="normal"
              label="Password"
              variant="outlined"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              margin="normal"
              label="Confirm Password"
              variant="outlined"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <FormControl fullWidth margin="normal" variant="outlined">
              <InputLabel>Role</InputLabel>
              <Select
                value={role}
                onChange={(e) => setRole(e.target.value)}
                label="Role"
              >
                <MenuItem value="">
                  <em>None</em>
                </MenuItem>
                {roles.map((role) => (
                  <MenuItem key={role.id} value={role.name}>{role.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={{ mt: 3 }}>
            <Button type="submit" variant="contained" color="primary" fullWidth>
              Update
            </Button>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
};

export default EditUser;

